<template>
  <div class="mb-2">
    <router-link :to="{ name: 'contentViewer', query: {page_uri: '/kifu'} }" class="text-decoration-none">
      <img src="/images/banner/kifu_mini.png" class="w-100">
    </router-link>
  </div>
  <div class="mb-2">
    <a href="https://academia.securite.jp/" target="_blank" class="text-decoration-none">
      <img src="/images/banner/academia_mini.png" class="w-100">
    </a>
  </div>
  <div class="mb-2">
    <a href="https://www.musicup.jp/" target="_blank" class="text-decoration-none">
      <img src="/images/banner/msup_mini.png" class="w-100">
    </a>
  </div>
</template>

<script>
export default {
  name: 'SpecialPageList'
}
</script>